// @noflow
import React, { useCallback, useState } from 'react'

import * as Sentry from '@/utils/sentry'

import { useModal } from '@/hooks/useModal'

import { Button } from '@/components/elements/atoms/Button'
import Text from '@/components/elements/atoms/Text/Text'

import STYLES from './EditRecipesNotSaved.module.sass'

import ModalLayout from '../../layout'

type Props = {
  id: string
  data: {
    onSave: () => Promise<void>
    onCancel?: () => void
  }
}

const EditRecipesNotSaved = ({ data, id }: Props): JSX.Element => {
  const { closeModal } = useModal(id)

  const { onSave, onCancel } = data

  const [loading, setLloading] = useState(false)

  const handleSave = useCallback(async () => {
    setLloading(true)
    try {
      await onSave()
      closeModal()
    } catch (error) {
      Sentry.captureException('Unable to update recipes', { extra: error })
    } finally {
      setLloading(false)
    }
  }, [onSave, closeModal])

  const handleCancel = useCallback(() => {
    typeof onCancel === 'function' && onCancel()

    closeModal()
  }, [onCancel, closeModal])

  return (
    <ModalLayout
      title={{
        text: 'edit_recipes.fresh_meals_page.updates_not_saved_modal.title',
        namespace: 'account'
      }}
    >
      <Text
        margin={false}
        text="edit_recipes.fresh_meals_page.updates_not_saved_modal.subtitle"
        namespace="account"
      />

      <section className={STYLES.buttons}>
        <Button
          disabled={loading}
          identifier="edit_recipes_not_saved_modal.save_cta"
          typography={{
            namespace: 'account',
            text: 'edit_recipes.fresh_meals_page.updates_not_saved_modal.save_cta'
          }}
          onClick={handleSave}
        />
        <Button
          disabled={loading}
          identifier="edit_recipes_not_saved_modal.cancel_cta"
          variant="secondary"
          typography={{
            namespace: 'account',
            text: 'edit_recipes.fresh_meals_page.updates_not_saved_modal.cancel_cta'
          }}
          onClick={handleCancel}
        />
      </section>
    </ModalLayout>
  )
}

export { EditRecipesNotSaved }
